/**
 * Зеркало `apps/api/src/images/image-presets.ts`: клиент кадрирует и сжимает по
 * тем же числам, что сервер применяет повторно. Расходиться им нельзя — иначе
 * пользователь увидит одно, а сохранится другое.
 */
export const IMAGE_KINDS = ['avatar', 'banner', 'cover', 'preview'] as const;

export type ImageKind = (typeof IMAGE_KINDS)[number];

export interface ImagePreset {
  /** Соотношение сторон рамки кадрирования. `null` — свободное. */
  aspect: number | null;
  maxSide: number;
  /** Целевой вес после сжатия в браузере, МБ. */
  maxSizeMb: number;
  /** Круглая рамка у аватара: он и показывается кругом. */
  round: boolean;
  title: string;
}

export const IMAGE_PRESETS: Record<ImageKind, ImagePreset> = {
  avatar: { aspect: 1, maxSide: 512, maxSizeMb: 0.4, round: true, title: 'Аватар' },
  banner: { aspect: 16 / 6, maxSide: 1600, maxSizeMb: 1, round: false, title: 'Баннер' },
  cover: { aspect: 4 / 3, maxSide: 1200, maxSizeMb: 0.8, round: false, title: 'Обложка' },
  preview: { aspect: null, maxSide: 1600, maxSizeMb: 1, round: false, title: 'Изображение' },
};
